<template>
<div class="chapter">
<div class="inner_page">
<p class="P_WFP_ChapHead" id="auto_bookmark_table_of_contents_1"><span>Dedication</span></p>
<p class="P_WFP_Quote__And__Centre_Alignment"><span>For Brian, Bruce and Penny. For all the years they tiptoed while their father was writing.</span></p>
<p class="P_WFP_QuoteByLine__And__Centre_Alignment"><span>—Frank Herbert</span></p>
<p class="P_Normal__And__Times_New_Roman__And__Centre_Alignment__And__Left_Indent"><span> </span></p>
<p class="P_WFP_Quote__And__Centre_Alignment"><span>For all those healers who ease our suffering; for people who feed people, then ask of them virtue; for our friends—gratitude and affection.</span></p>
<p class="P_WFP_QuoteByLine__And__Centre_Alignment"><span>—Bill Ransom</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0004.vue?3db8f2dc